// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fcce82ee","398":"69834049","536":"ef2b2481","684":"043ba215","886":"79fc338a","952":"9d035d6b"}[chunkId] + ".chunk.js";
};